import _ from 'underscore';
import { Component } from 'react';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import withSearchResult from '../common/with-search-result';
import { GuideSectionSearchResult, GuideTaskSearchResult, SearchResultItemDetails } from '../common/search-result';

class LearnerHomeSearchResultInner extends Component {
  render() {
    return this.renderDetails();
  }

  renderDetails = () => {
    if (_.contains([...APP_CONSTANTS.SEARCHABLE_TOP_LEVEL_CONTENT_TYPES], this.props.type)) {
      return this.renderTopLevelContentDetails(this.props.type);
    }

    switch (this.props.type) {
      case 'Challenge':
        return this.renderChallengeDetails();
      case 'Guide':
        return this.renderGuideDetails();
      case 'Guide Task':
        return this.renderGuideTask();
      case 'Guide Section':
        return this.renderGuideSection();
      case 'Path':
        return this.renderPathDetails();
      case 'Resource':
        return this.renderResourceDetails();
      case 'University':
        return this.renderUniversityDetails();
      default:
        console.log('Error. Tried to render an item type that does not exist.');
    }
  };

  renderSearchResultItemDetail = (type, name, content = null, tags = null, dim = false) => (
    <SearchResultItemDetails content={content} dim={dim} type={type} matchedTagContent={tags} name={name} />
  );

  renderPathDetails = () =>
    this.renderSearchResultItemDetail(AssetPickerTypes.SERIES, this.props.name, this.props.content, this.props.tags);

  renderGuideSection = () => <GuideSectionSearchResult guideTitle={this.props.guideTitle} name={this.props.name} />;

  renderGuideTask = () => (
    <GuideTaskSearchResult
      content={this.props.content}
      guideTitle={this.props.guideTitle}
      name={this.props.name}
      sectionTitle={this.props.sectionTitle}
    />
  );

  renderResourceDetails = () =>
    this.renderSearchResultItemDetail(AssetPickerTypes.RESOURCE, this.props.name, null, this.props.tags);

  renderChallengeDetails = () =>
    this.renderSearchResultItemDetail(AssetPickerTypes.CHALLENGE, this.props.name, this.props.content, this.props.tags);

  renderGuideDetails = () =>
    this.renderSearchResultItemDetail(AssetPickerTypes.GUIDE, this.props.name, this.props.content, this.props.tags);

  renderUniversityDetails = () =>
    this.renderSearchResultItemDetail(AssetPickerTypes.UNIVERSITY, this.props.name, null, this.props.tags);

  renderTopLevelContentDetails = (contentType) =>
    this.renderSearchResultItemDetail(contentType, this.props.name, this.props.content, this.props.tags);
}

const LearnerHomeSearchResult = withSearchResult(LearnerHomeSearchResultInner);

export default LearnerHomeSearchResult;
